// extracted by mini-css-extract-plugin
module.exports =  {"row":"a10a3f92e9--row--FpXeM","cell":"a10a3f92e9--cell--GJCKF"};